import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JroHeaderNew = _resolveComponent("JroHeaderNew")!
  const _component_JroLinksNew = _resolveComponent("JroLinksNew")!
  const _component_JroProjectsNew = _resolveComponent("JroProjectsNew")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(_component_JroHeaderNew),
    _createVNode(_component_JroLinksNew),
    _createVNode(_component_JroProjectsNew)
  ]))
}